import React, { FC } from 'react'
import { Field } from 'redux-form'
import { Input } from 'semantic-ui-react'
//@ts-ignore
import { ComponentContainer } from 'shared/StyledComponents'
import { AccSearchBalCodeIdComponentProps } from '../components.type'

const component: FC<AccSearchBalCodeIdComponentProps> = ({ input, meta: { submitting }, type }) => (
  <ComponentContainer input>
    <Input
      fluid
      {...input}
      onChange={(_, { value }) => input.onChange(value)}
      onFocus={(e: React.FocusEvent<HTMLInputElement>) => e.target.select()}
      type={type}
      loading={submitting}
    />
  </ComponentContainer>
)

const AccSearchBalCodeId = () => <Field name="balCodeId" component={component} type="text" />

export default AccSearchBalCodeId
